import * as THREE from 'three'

import Loader from './Utils/Loader.js'
import EventEmitter from './Utils/EventEmitter.js'

// Matcaps
import matcapBeigeSource from '../models/matcaps/beige.png'
import matcapBlackSource from '../models/matcaps/black.png'
import matcapOrangeSource from '../models/matcaps/orange.png'
import matcapRedSource from '../models/matcaps/red.png'
import matcapWhiteSource from '../models/matcaps/white.png'
import matcapGreenSource from '../models/matcaps/green.png'
import matcapBrownSource from '../models/matcaps/brown.png'
import matcapGraySource from '../models/matcaps/gray.png'
import matcapEmeraldGreenSource from '../models/matcaps/emeraldGreen.png'
import matcapPurpleSource from '../models/matcaps/purple.png'
import matcapBlueSource from '../models/matcaps/blue.png'
import matcapYellowSource from '../models/matcaps/yellow.png'
import matcapMetalSource from '../models/matcaps/metal.png'

// Artworks
import artworksBoardStructureSource from '../models/artworks/board/structure.glb'
import artworksBoardCollisionSource from '../models/artworks/board/collision.glb'
import artworksBoardStructureFloorShadowSource from '../models/artworks/board/floorShadow.png'
import artworksBoardPlaneSource from '../models/artworks/board/plane.glb'
import artworksFrameStructureSource from '../models/artworks/frame/structure.glb'
// import artworksFramePlaneSource from '../models/artworks/frame/plane.glb'

import artworksDistinctionsAwwwardsBaseSource from '../models/artworks/distinctions/awwwards/base.glb'
import artworksDistinctionsAwwwardsCollisionSource from '../models/artworks/distinctions/awwwards/collision.glb'
import artworksDistinctionsFWABaseSource from '../models/artworks/distinctions/fwa/base.glb'
import artworksDistinctionsFWACollisionSource from '../models/artworks/distinctions/fwa/collision.glb'
import artworksDistinctionsCSSDABaseSource from '../models/artworks/distinctions/cssda/base.glb'
import artworksDistinctionsCSSDACollisionSource from '../models/artworks/distinctions/cssda/collision.glb'

import artworksBosch1FloorSource from '../models/artworks/bosch1/floorTexture.png'
import floorSource from '../models/floor/floor.jpg'
import blueNoiseSource from '../models/effects/LDR_RGB1_0.png'


// Area
import areaKeyEnterSource from '../models/area/keyEnter.png'
import areaEnterSource from '../models/area/enter.png'
import areaOpenSource from '../models/area/open.png'
import areaBuySource from '../models/area/buy.png'
import areaResetSource from '../models/area/reset.png'
import areaQuestionMarkSource from '../models/area/questionMark.png'

// Tiles
import tilesABaseSource from '../models/tiles/a/base.glb'
import tilesACollisionSource from '../models/tiles/a/collision.glb'

import tilesBBaseSource from '../models/tiles/b/base.glb'
import tilesBCollisionSource from '../models/tiles/b/collision.glb'

import tilesCBaseSource from '../models/tiles/c/base.glb'
import tilesCCollisionSource from '../models/tiles/c/collision.glb'

import tilesDBaseSource from '../models/tiles/d/base.glb'
import tilesDCollisionSource from '../models/tiles/d/collision.glb'

import tilesEBaseSource from '../models/tiles/e/base.glb'
import tilesECollisionSource from '../models/tiles/e/collision.glb'

// Wigs
import wig1Source from '../models/wigs/wig1.glb'
import wig2Source from '../models/wigs/wig2.glb'
import wig3Source from '../models/wigs/wig3.glb'
import wig4Source from '../models/wigs/wig4.glb'

export default class Resources extends EventEmitter
{
    constructor()
    {
        super()

        this.loader = new Loader()
        this.items = {}

        this.loader.load([
            // Matcaps
            { name: 'matcapBeige', source: matcapBeigeSource, type: 'texture' },
            { name: 'matcapBlack', source: matcapBlackSource, type: 'texture' },
            { name: 'matcapOrange', source: matcapOrangeSource, type: 'texture' },
            { name: 'matcapRed', source: matcapRedSource, type: 'texture' },
            { name: 'matcapWhite', source: matcapWhiteSource, type: 'texture' },
            { name: 'matcapGreen', source: matcapGreenSource, type: 'texture' },
            { name: 'matcapBrown', source: matcapBrownSource, type: 'texture' },
            { name: 'matcapGray', source: matcapGraySource, type: 'texture' },
            { name: 'matcapEmeraldGreen', source: matcapEmeraldGreenSource, type: 'texture' },
            { name: 'matcapPurple', source: matcapPurpleSource, type: 'texture' },
            { name: 'matcapBlue', source: matcapBlueSource, type: 'texture' },
            { name: 'matcapYellow', source: matcapYellowSource, type: 'texture' },
            { name: 'matcapMetal', source: matcapMetalSource, type: 'texture' },


            // Artwork
            { name: 'artworksBoardStructure', source: artworksBoardStructureSource },
            { name: 'artworksBoardCollision', source: artworksBoardCollisionSource },
            { name: 'artworksBoardStructureFloorShadow', source: artworksBoardStructureFloorShadowSource, type: 'texture' },
            { name: 'artworksBoardPlane', source: artworksBoardPlaneSource },

            { name: 'artworksFrameStructure', source: artworksFrameStructureSource },
            // { name: 'artworksFramePlane', source: artworksFramePlaneSource },

            { name: 'artworksDistinctionsAwwwardsBase', source: artworksDistinctionsAwwwardsBaseSource },
            { name: 'artworksDistinctionsAwwwardsCollision', source: artworksDistinctionsAwwwardsCollisionSource },
            { name: 'artworksDistinctionsFWABase', source: artworksDistinctionsFWABaseSource },
            { name: 'artworksDistinctionsFWACollision', source: artworksDistinctionsFWACollisionSource },
            { name: 'artworksDistinctionsCSSDABase', source: artworksDistinctionsCSSDABaseSource },
            { name: 'artworksDistinctionsCSSDACollision', source: artworksDistinctionsCSSDACollisionSource },


            { name: 'artworksBosch1Floor', source: artworksBosch1FloorSource, type: 'texture' },

            { name: 'floor', source: floorSource, type: 'texture' },

            { name: 'blueNoise', source: blueNoiseSource, type: 'texture' },


            // Areas
            { name: 'areaKeyEnter', source: areaKeyEnterSource, type: 'texture' },
            { name: 'areaEnter', source: areaEnterSource, type: 'texture' },
            { name: 'areaOpen', source: areaOpenSource, type: 'texture' },
            { name: 'areaBuy', source: areaBuySource, type: 'texture' },
            { name: 'areaReset', source: areaResetSource, type: 'texture' },
            { name: 'areaQuestionMark', source: areaQuestionMarkSource, type: 'texture' },

            // Tiles
            { name: 'tilesABase', source: tilesABaseSource },
            { name: 'tilesACollision', source: tilesACollisionSource },

            { name: 'tilesBBase', source: tilesBBaseSource },
            { name: 'tilesBCollision', source: tilesBCollisionSource },

            { name: 'tilesCBase', source: tilesCBaseSource },
            { name: 'tilesCCollision', source: tilesCCollisionSource },

            { name: 'tilesDBase', source: tilesDBaseSource },
            { name: 'tilesDCollision', source: tilesDCollisionSource },

            { name: 'tilesEBase', source: tilesEBaseSource },
            { name: 'tilesECollision', source: tilesECollisionSource },


            // Wigs
            { name: 'wig1', source: wig1Source },
            { name: 'wig2', source: wig2Source },
            { name: 'wig3', source: wig3Source },
            { name: 'wig4', source: wig4Source }
        ])

        this.loader.on('fileEnd', (_resource, _data) =>
        {
            this.items[_resource.name] = _data

            // Texture
            if(_resource.type === 'texture')
            {
                const texture = new THREE.Texture(_data)
                texture.needsUpdate = true

                this.items[`${_resource.name}Texture`] = texture
            }

            // Trigger progress
            this.trigger('progress', [this.loader.loaded / this.loader.toLoad])
        })

        this.loader.on('end', () =>
        {
            // Trigger ready
            this.trigger('ready')
        })
    }
}
